import { useState } from "#app";
import { ref, unref, computed } from "vue";
export const useModal = (id = "") => {
  let _Modals = useState("useModal__modals", () => ({}));
  const modalId = id ? ref(id) : ref("");
  const statusModal = computed(
    () => _Modals.value[unref(modalId)]
  ) ?? false;
  const initModal = (id2) => {
    if (!_Modals.value[id2]) {
      _Modals.value[id2] = false;
    }
    modalId.value = id2;
  };
  const clearModals = () => {
    _Modals.value = {};
    modalId.value = "";
  };
  const destroyModals = () => {
    if (modalId.value in _Modals.value) {
      delete _Modals.value[unref(modalId)];
    }
  };
  const destroyModal = (optId) => {
    delete _Modals.value[optId ?? modalId.value];
  };
  const switchModalState = (id2, state) => {
    if (id2 in _Modals.value) {
      _Modals.value[id2] = state;
    }
  };
  const openModal = (optId) => {
    const modalToOpen = optId ?? modalId.value;
    Object.keys(_Modals.value).includes(modalToOpen) && switchModalState(modalToOpen, true);
  };
  const closeModal = (optId) => {
    const modalToOpen = optId ?? modalId.value;
    Object.keys(_Modals.value).includes(modalToOpen) && switchModalState(modalToOpen, false);
  };
  return {
    statusModal,
    initModal,
    clearModals,
    destroyModals,
    openModal,
    closeModal,
    destroyModal,
    switchModalState
  };
};
